import dynamic from 'next/dynamic'
import { type ComponentType } from 'react'
import { SHELF_RENDER_TYPE } from '@/features/shared/constants/shelves'
import { type Shelf } from '@/features/shop/services/Shelves/types'
import { getShelfLoader } from '@/features/shop/components/Shelf/ShelfLoaders'

const ProductShelf = dynamic(async () => (await import('./ProductShelf')).ProductShelf, {
  ssr: false,
  loading: getShelfLoader(SHELF_RENDER_TYPE.PRODUCT),
})

const FeaturedPromotionProductShelf = dynamic(
  async () => (await import('./FeaturedPromotionProductShelf')).FeaturedPromotionProductShelf,
  {
    ssr: false,
    loading: getShelfLoader(SHELF_RENDER_TYPE.FEATURED_PROMOTIONS),
  },
)

const CampaignPromoShelfRenderer = dynamic(
  async () => (await import('./CampaignPromoShelfRenderer')).CampaignPromoShelfRenderer,
  { ssr: false, loading: getShelfLoader(SHELF_RENDER_TYPE.CAMPAIGN_PROMOS) },
)

const BuyAgainProductShelf = dynamic(
  async () => (await import('./BuyAgainProductShelf')).BuyAgainProductShelf,
  {
    ssr: false,
    loading: getShelfLoader(SHELF_RENDER_TYPE.BUY_AGAIN_SINGLE_RETAILER),
  },
)

export const shelfComponents = {
  [SHELF_RENDER_TYPE.FEATURED_PROMOTIONS]: FeaturedPromotionProductShelf,
  [SHELF_RENDER_TYPE.PRODUCT]: ProductShelf,
  [SHELF_RENDER_TYPE.CAMPAIGN_PROMOS]: CampaignPromoShelfRenderer,
  [SHELF_RENDER_TYPE.BUY_AGAIN_SINGLE_RETAILER]: BuyAgainProductShelf,
} satisfies Record<SHELF_RENDER_TYPE, ComponentType<{ shelf: Shelf; shelfIndex: number }>>
